import 'whatwg-fetch';
import 'src/utils/object.isInfinite.polyfill.js';
import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _find from 'lodash/find';
import ReadyHelmet from './ReadyHelmet';
import Header from './Header';
import NotSupportedBrowser from 'src/components/NotSupportedBrowser';
import styles from './layout.module.css';
import './layout.css';
import { meta } from '../constants/meta';

const getAllMeta = page => {
  if (page !== null && !meta[page]) {
    throw new Error(`No page meta. Page: ${page}.`);
  }

  return meta[page];
};

const getTitle = page => {
  const allMeta = getAllMeta(page);
  return _get(allMeta, 'title', 'Hiveon Pool – Most profitable and efficient mining pool');
};

const getMeta = page => {
  const allMeta = getAllMeta(page);
  return _get(allMeta, 'meta', []);
};

const Layout = ({ children, data, page = 'default' }) => (
  <>
    <NotSupportedBrowser>
      <ReadyHelmet title={getTitle(page)} meta={getMeta(page)} />
      <Header/>
      <div
        style={{
          margin: '0 auto',
          paddingTop: 0,
        }}
      >
        <div className={styles.intro}></div>
        {children}
      </div>
    </NotSupportedBrowser>
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export default Layout
